import { BarChart2, Globe, Rocket } from "lucide-react";

export const ProjectShowcase = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Growing Impact</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Building effective web solutions that help businesses establish their digital presence
            and grow online.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <Globe className="h-12 w-12 text-blue-600 mb-4" />,
              metric: "50+",
              label: "Websites Delivered",
              description: "Successfully completed projects for small businesses"
            },
            {
              icon: <BarChart2 className="h-12 w-12 text-blue-600 mb-4" />,
              metric: "95%",
              label: "Client Satisfaction",
              description: "Happy clients who recommend our services"
            },
            {
              icon: <Rocket className="h-12 w-12 text-blue-600 mb-4" />,
              metric: "30%",
              label: "Performance Boost",
              description: "Average improvement in website speed"
            }
          ].map((stat, index) => (
            <div 
              key={index}
              className="p-8 rounded-xl bg-white shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex flex-col items-center text-center">
                {stat.icon}
                <span className="text-4xl font-bold text-blue-600 mb-2">{stat.metric}</span>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{stat.label}</h3>
                <p className="text-gray-600">{stat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};